(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aura-card-swipe"] && !Shopify.designMode) return;
  try {
    function paint(s) {
    var t = s.querySelector('.aura-swipe__track:not([hidden])'), d = s.querySelector('.aura-swipe__dots');
    if (!t || !d) return;
    var n = t.children.length, i = t.clientWidth ? Math.round(t.scrollLeft / t.clientWidth) : 0;
    if (d.children.length !== n) d.innerHTML = n > 1 ? new Array(n + 1).join('<span></span>') : '';
    for (var k = 0; k < d.children.length; k++) d.children[k].className = k === i ? 'on' : '';
  }
  function setup(s) {
    if (s.dataset.ready) return;
    s.dataset.ready = '1';
    s.addEventListener('scroll', function () { requestAnimationFrame(function () { paint(s); }); }, true);
    var card = s.closest('.product-card');
    if (card) card.addEventListener('change', function (e) {
      if (e.target.type !== 'radio' || !e.target.closest('product-card-swatches')) return;
      var tracks = s.querySelectorAll('.aura-swipe__track'), hit = null;
      for (var k = 0; k < tracks.length; k++) if (tracks[k].dataset.colour === e.target.value) hit = tracks[k];
      if (!hit) return;
      for (k = 0; k < tracks.length; k++) tracks[k].hidden = tracks[k] !== hit;
      hit.scrollLeft = 0;
      paint(s);
    });
    paint(s);
  }
  function init() { document.querySelectorAll('.aura-swipe').forEach(setup); }
  init();
  new MutationObserver(init).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
